import React from "react";

const SubscribePopup = ({ onClose }) => {
  return (
    <div className="email-popup">
      <div className="email-popup-content">
        <button
          className="email-close-button"
          onClick={onClose}
          aria-label="Close popup"
        >
          &times;
        </button>
        <p className="thank-you-message text-center">
          Thank you for subscribing! <br />
          Meanwhile, talk to our manufacturing expert.
        </p>
      </div>
    </div>
  );
};

export default SubscribePopup;
